import {
  Accordion,
  Box,
  Card,
  Flex,
  Hide,
  useTabletMediaQuery,
} from '@iheartjane/reefer';
import type { ReactNode } from 'react';
import React from 'react';

import type { PrepaymentProviders } from '@jane/shared-ecomm/providers';
import { useCheckout } from '@jane/shared-ecomm/providers';

import type { PaymentOptions } from '../util/hooks/usePaymentOptions';
import { PaymentMethods } from '../util/hooks/usePaymentOptions';
import { useCheckoutPayments } from './CheckoutPaymentsProvider';

import styles from '../checkout.module.css';

const REQUIRE_LOG_IN = [PaymentMethods.paytender, PaymentMethods.stronghold];

interface CheckoutPaymentsAccordionItemProps {
  children?: ReactNode;
  id: PaymentOptions;
}

export const CheckoutPaymentsAccordionItem = ({
  children,
  id,
}: CheckoutPaymentsAccordionItemProps) => {
  const isMobile = useTabletMediaQuery({ width: 'max' });

  const {
    customer: { authenticated },
    guestCheckout: { preAuthSelection, setShowLoginModal, setPreAuthSelection },
  } = useCheckout();

  const { selectPaymentOption, selected } = useCheckoutPayments();

  const requiresLogin =
    !authenticated && (REQUIRE_LOG_IN as PaymentOptions[]).includes(id);
  const isSelected = selected === id || preAuthSelection === id;

  const childrenArray = React.Children.toArray(children);
  const [radioField, ...paymentMethodForm] = childrenArray;

  const handleSelectMethod = () => {
    if (requiresLogin) {
      selectPaymentOption(null);
      setPreAuthSelection(id as PrepaymentProviders);
      setShowLoginModal(true);
      return;
    }

    if (preAuthSelection !== 'janeGold') {
      setPreAuthSelection(null);
    }

    selectPaymentOption(id);
  };

  return (
    <Card
      className={styles['paymentsCard']}
      borderWidth="2px"
      mb={16}
      border={isSelected ? 'primary' : 'grays-ultralight'}
      width="100%"
      flat
    >
      <Accordion.Item id={id} expanded={isSelected && !requiresLogin}>
        <Accordion.Heading
          as="div"
          onClick={handleSelectMethod}
          disableExpansion={paymentMethodForm.length === 0}
          p={24}
        >
          <Flex alignItems="center" width="100%">
            {radioField}
          </Flex>
        </Accordion.Heading>
        <Accordion.Content destroyOnClose={false}>
          <Hide isHidden={!isSelected} hideFromScreenReader>
            {paymentMethodForm.length > 0 && (
              <Box ml={isMobile ? 0 : 32}>{paymentMethodForm}</Box>
            )}
          </Hide>
        </Accordion.Content>
      </Accordion.Item>
    </Card>
  );
};
